import { render, staticRenderFns } from "./adminApplicationDetails.vue?vue&type=template&id=f4c2c92c"
import script from "./adminApplicationDetails.vue?vue&type=script&lang=js"
export * from "./adminApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./adminApplicationDetails.vue?vue&type=style&index=0&id=f4c2c92c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports